/** @jsx jsx */

import React, {
  useContext,
  useEffect,
  useRef,
  forwardRef,
  useState,
} from 'react'

import { jsx, Box, Flex, Image } from 'theme-ui'
import Slider from 'react-slick'

import { useBreakpointIndex } from '@theme-ui/match-media'

import { css, Global } from '@emotion/core'
import { getOverlayTag, NewTag } from '../../blocks/ProductHero'
import styled from '@emotion/styled'
import chevronCircleLeftGray from '../../../icons/chevronCircleLeftGray.svg'
import chevronCircleRightGray from '../../../icons/chevronCircleRightGray.svg'
import chevronUp from '../../../icons/chevronUp.svg'
import chevronDown from '../../../icons/chevronDown.svg'
import { useWindowSize } from '../../../hooks/useWindowSize'

const Logo = styled.img``

export const slickStyles = css`
  .slick-list,
  .slick-slider,
  .slick-track {
    position: relative;
    display: block;
    outline: 0px !important;
  }
  .slick-loading .slick-slide,
  .slick-loading .slick-track {
    visibility: hidden;
  }
  .slick-slider {
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }
  .slick-list {
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: 0;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }
  .slick-slider .slick-list,
  .slick-slider .slick-track {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .slick-track {
    top: 0;
    left: 0;
  }
  .slick-track:after,
  .slick-track:before {
    display: table;
    content: '';
  }
  .slick-track:after {
    clear: both;
  }
  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
  }
  [dir='rtl'] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
    display: none;
  } /*# sourceMappingURL=slick.min.css.map */

  @charset 'UTF-8';
  .slick-dots,
  .slick-next,
  .slick-prev {
    position: absolute;
    display: block;
    padding: 0;
  }
  .slick-dots li button:before,
  .slick-next:before,
  .slick-prev:before {
    font-family: slick;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .slick-loading .slick-list {
    background: url(ajax-loader.gif) center center no-repeat #fff;
  }

  .slick-next,
  .slick-prev {
    font-size: 0;
    line-height: 0;
    top: 50%;
    width: 20px;
    height: 20px;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: 0;
    background: 0 0;
  }
  .slick-next:focus,
  .slick-next:hover,
  .slick-prev:focus,
  .slick-prev:hover {
    color: transparent;
    outline: 0;
    background: 0 0;
  }
  .slick-next:focus:before,
  .slick-next:hover:before,
  .slick-prev:focus:before,
  .slick-prev:hover:before {
    opacity: 1;
  }
  .slick-next.slick-disabled:before,
  .slick-prev.slick-disabled:before {
    opacity: 0.25;
  }
  .slick-disabled {
    display: none;
  }
  .slick-next:before,
  .slick-prev:before {
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #fff;
  }
  .slick-prev {
    left: -25px;
  }
  [dir='rtl'] .slick-prev {
    right: -25px;
    left: auto;
  }
  .slick-prev:before {
    content: '←';
  }
  .slick-next:before,
  [dir='rtl'] .slick-prev:before {
    content: '→';
  }
  .slick-next {
    right: -25px;
  }
  [dir='rtl'] .slick-next {
    right: auto;
    left: -25px;
  }
  [dir='rtl'] .slick-next:before {
    content: '←';
  }
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }
  .slick-dots {
    bottom: -25px;
    width: 100%;
    margin: 0;
    list-style: none;
    text-align: center;
  }
  .slick-dots li {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
  }
  .slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: 0;
    background: 0 0;
  }
  .slick-dots li button:focus,
  .slick-dots li button:hover {
    outline: 0;
  }
  .slick-dots li button:focus:before,
  .slick-dots li button:hover:before {
    opacity: 1;
  }
  .slick-dots li button:before {
    font-size: 20px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '•';
    text-align: center;
    opacity: 0.25;
    color: white;
  }
  .slick-dots li.slick-active button:before {
    opacity: 0.75;
  }
  /*# sourceMappingURL=slick-theme.min.css.map */
`

function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <Logo
      className={className}
      sx={{
        ...style,
        zIndex: 20,
        width: 20,
        display: 'relative',
        top: -20,
        left: 32,
        color: 'black',
      }}
      onClick={onClick}
      src={chevronUp}
    />
  )
}

function NextArrow(props) {
  const { className, style, onClick } = props

  return (
    <Logo
      src={chevronDown}
      className={className}
      sx={{
        ...style,
        zIndex: 20,
        width: 20,
        position: 'relative',
        top: '15px',
        left: 32,

        color: 'black',
      }}
      onClick={onClick}
      alt="next"
    />
  )
}

function ImgPrevArrow(props) {
  const { className, onClick } = props
  return (
    <Logo
      className={className}
      sx={{
        zIndex: 20,
        position: 'absolute',
        left: 0,
        color: 'grey',
        height: '40px',
        width: '30px',
      }}
      onClick={onClick}
      src={chevronCircleLeftGray}
      alt="prev"
    />
  )
}

function ImgNextArrow(props) {
  const { className, onClick } = props
  return (
    <Logo
      className={className}
      sx={{
        zIndex: 20,
        position: 'absolute',
        top: '50%',
        right: 0,
        color: 'grey',
        height: '40px',
        width: '30px',
      }}
      onClick={onClick}
      src={chevronCircleRightGray}
    />
  )
}

const ProductImageCarousel = ({ slides, ...props }) => {
  const index = useBreakpointIndex()
  const [state, setState] = useState({
    nav1: null,
    nav2: null,
    currentSlideIndex: 0,
  })
  const slider1 = useRef()
  const slider2 = useRef()

  useEffect(() => {
    setState({
      ...state,
      nav1: slider1.current,
      nav2: slider2.current,
    })
  }, [])

  const { nav1, nav2 } = state
  const overlayTag = getOverlayTag(props.tags)

  const { mobile } = useWindowSize()

  return (
    <Box {...props}>
      <Flex sx={{ justifyContent: 'space-around' }}>
        {/* <Box
          sx={{
            display: ['none', null, 'block'],
            width: '85px',
            marginRight: [null, null, 30],
            maxWidth: '85px',
          }}
        >
          <Slider
            css={css`
              .slick-list .slick-track {
                max-height: 520px !important;
              }
            `}
            asNavFor={nav2}
            ref={slider => (slider1.current = slider)}
            slidesToShow={5}
            swipeToSlide
            focusOnSelect
            vertical
            infinite={false}
            prevArrow={<PrevArrow />}
            initialSlide={0}
            nextArrow={<NextArrow />}
            beforeChange={(prev, current) =>
              setState({ ...state, currentSlideIndex: current })
            }
          >
            {slides.map((i, index) => {
              return (
                <Box
                  key={index}
                  sx={{
                    maxHeight: 88,
                    border:
                      state.currentSlideIndex === index && '2px solid black',
                    objectFit: 'cover',
                    mb: '12px',
                    boxShadow: 'default',
                    position: 'relative',
                  }}
                >
                  {i}
                </Box>
              )
            })}
          </Slider>
        </Box> */}
        <Box sx={{ flex: 1, maxWidth: ['none', null, 700] }}>
          <DotSlider
            asNavFor={nav1}
            ref={slider => (slider2.current = slider)}
            slidesToShow={1}
            swipeToSlide
            focusOnSelect
            dots={mobile ? true : false}
            prevArrow={index < 3 && <ImgPrevArrow />}
            nextArrow={index < 3 && <ImgNextArrow />}
            beforeChange={(prev, current) =>
              setState({ ...state, currentSlideIndex: current })
            }
            css={css`
              .slick-dots {
                bottom: 8px !important;
              }
            `}
            renderItem={slides.map((i, k) => (
              <Box sx={{ position: 'relative' }} key={k}>
                {/* {k === 0 && overlayTag && (
                  <NewTag text={overlayTag} smallTag={false} />
                )} */}
                {i}
              </Box>
            ))}
          />
        </Box>
      </Flex>
    </Box>
  )
}

// export const MobileSlider = forwardRef(({ slides, ...props }, ref) => {
//   return (
//     <>
//       <ScrollMenu
//         alignCenter={false}
//         wrapperStyle={{
//           overflow: 'hidden',
//         }}
//         data={
//           !props.renderItem ? slides.map(i => <div>{i}</div>) : props.renderItem
//         }
//         {...props}
//         ref={ref}
//       />
//     </>
//   )
// })

export const DotSlider = forwardRef(({ slides, ...props }, ref) => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
  }

  return (
    <>
      <Slider
        {...settings}
        css={css`
          .slick-dots li button:before {
            font-size: 15px !important;
            line-height: 15px !important;
            opacity: 0.7 !important;
            color: gray;
            margin: 0px;
            margin-top: 2px;
          }
          .slick-dots li.slick-active button:before {
            opacity: 0.3 !important;
            font-size: 25px !important;
            line-height: 15px !important;
          }
          .slick-dots li {
            margin: 0px;
          }
        `}
        {...props}
        ref={ref}
      >
        {!props.renderItem && slides.map(i => <div>{i}</div>)}
        {props.renderItem && props.renderItem}
      </Slider>
    </>
  )
})

// const ProductImageCarousel = ({ slides }) => {
//   return (
//     <>
//       <MobileSlider sx={{ display: ['block', null, 'none'] }} slides={slides} />
//       <DesktopSlider
//         sx={{ display: ['none', null, 'block'] }}
//         slides={slides}
//       />
//     </>
//   )
// }

export default ProductImageCarousel
